import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import React, { useState, useEffect } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import Router from "./router";
import "./styles/css/global.scss";
import { Toaster } from "react-hot-toast";
import DynamicFavicon from "./components/DynamicFavicon";
import SubscriptionExpiredPopup from "./components/SubscriptionExpiredPopup";
import { subscriptionManager } from "./utils/subscriptionManager";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      retry: false,
    },
  },
});

function App() {
  console.log("App === ", window.location.hostname, window.location);
  const [showSubscriptionPopup, setShowSubscriptionPopup] = useState(false);

  // Subscribe to subscription expiration events from axios interceptor
  // Only shows popup when 423 status code is received
  useEffect(() => {
    console.log("[App] Setting up subscription manager listener");
    
    const unsubscribe = subscriptionManager.subscribe((isExpired) => {
      console.log("[App] Subscription status changed:", isExpired);
      // Only show popup when explicitly notified (i.e., when 423 is received)
      if (isExpired) {
        console.log("[App] Setting popup to show");
        setShowSubscriptionPopup(true);
      } else {
        console.log("[App] Setting popup to hide");
        setShowSubscriptionPopup(false);
      }
    });

    console.log("[App] Subscription manager listener set up");

    // Cleanup subscription on unmount
    return () => {
      console.log("[App] Cleaning up subscription manager listener");
      unsubscribe();
    };
  }, []);

  const handleSelectPlan = async (plan) => {
    console.log("[App] Plan selected:", plan);
    try {
      // TODO: Implement your subscription API call here
      // Example:
      // await subscribeToPlan(plan.id);
      console.log("Selected plan:", plan);
      // After successful subscription, reset the subscription manager and close the popup
      console.log("[App] Resetting subscription manager");
      subscriptionManager.reset();
      setShowSubscriptionPopup(false);
    } catch (error) {
      console.error("[App] Error subscribing to plan:", error);
      // Handle error (show toast, etc.)
      // Don't close popup on error - let user try again
    }
  };

  const handleClosePopup = () => {
    console.log("[App] Close popup requested");
    // Optionally prevent closing if subscription is required
    // For now, allow closing but subscription manager will trigger it again if 423 is received
    setShowSubscriptionPopup(false);
  };

  console.log("[App] Render - showSubscriptionPopup:", showSubscriptionPopup);

  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <QueryClientProvider client={queryClient}>
          <ReactQueryDevtools initialIsOpen={false} />
          <DynamicFavicon />
          <Router />
          <SubscriptionExpiredPopup
            open={showSubscriptionPopup}
            onClose={handleClosePopup}
            onSelectPlan={handleSelectPlan}
            disableClose={true}
          />
          <Toaster
            position="top-center"
            gutter={12}
            containerStyle={{ margin: "8px" }}
            toastOptions={{
              success: {
                duration: 3000,
              },
              error: {
                duration: 5000,
              },
              style: {
                fontSize: "16px",
                maxWidth: "500px",
                padding: "16px 24px",
                backgroundColor: "white",
                color: "black",
              },
            }}
          />
        </QueryClientProvider>
      </LocalizationProvider>
    </div>
  );
}

export default App;
